module.exports = __webpack_public_path__ + "img/wallet1.80897453.jpg";